import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const AddOrUpdateOrderPrio = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.AddOrUpdateOrderPrio,
        method: RequestType.POST,
        data,
    });

const OrderPrioCommand = {
    AddOrUpdateOrderPrio,
};

export default OrderPrioCommand;
